document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".faq-list .accordion-input");

    accordions.forEach(accordion => {
        const svg = accordion.closest("label").querySelector("svg");
        const [plusIcon, minusIcon] = svg.querySelectorAll(".plus-icon, .minus-icon");

        const updateIcons = (isChecked) => {
            plusIcon.style.display = isChecked ? "none" : "block";
            minusIcon.style.display = isChecked ? "block" : "none";
        };
        updateIcons(accordion.checked);

        accordion.addEventListener("change", function () {
            const isChecked = this.checked;
            updateIcons(isChecked);

            accordions.forEach(otherAccordion => {
                if (otherAccordion !== this && otherAccordion.checked) {
                    const otherSvg = otherAccordion.closest("label").querySelector("svg");
                    const [otherPlusIcon, otherMinusIcon] = otherSvg.querySelectorAll(".plus-icon, .minus-icon");
                    otherAccordion.checked = false;
                    otherPlusIcon.style.display = "block";
                    otherMinusIcon.style.display = "none";
                }
            });
        });
    });
});

$(document).ready(function () {
    var len = $(".table_faq").find(".toc").length;
    if (len > 0) {
        $(".append_div").empty();
        $(".hidden_div").show();
        $(".toc").each(function (index, val) {
            $(
                ".append_div"
            ).append(`<li class="heading_table cursor-pointer pl-3 tracking-[1px] text-sm md:text-base lg:text-base text-[#FEFEFA]">
                    ${$(this).html()}</li>`);
        });
    }
    // console.log(len);
});

$(document).on("click", ".submit_apply_cop", function (e) {
    e.preventDefault();
    var t = { email: $(".email_submit").val(), [csrfName]: csrfHash };
    $.ajax({
        url: base_url + "apply-coupon/",
        method: "POST",
        data: t,
        dataType: "json",
        success: function (e) {
            true == e.error
                ? // $(".erroremail").html(e.email_error),
                createToast('error', e.email_error)
                : (createToast('success', e.success),
                    $("#subcribe_form")[0].reset(),
                    $(".erroremail").html(""));
        },
    });
});

$(document).on("click", ".heading_table", function () {
    var myTest = $(this).text().trim();
    var divtext;
    $(".toc").each(function (index, element) {
        // .replace(/[\d.]+/g, '').trim()
        divtext = $(this).text().trim();

        if (myTest == divtext) {
            $("html, body").animate(
                {
                    scrollTop: $(this).offset().top - 150,
                },
                1000
            );
            $(this).addClass("common_outline rounded-sm back_color_common text-white");
            setTimeout(() => {
                $(this).removeClass("common_outline rounded-sm back_color_common text-white");
            }, 2000);
        }
    });
});

var notifications = document.querySelector(".notification");
function createToast(type, message,link=false) {
    if(typeof message!=='string'){
        if(message?.message){
            message=message.message;
        }else{
            message='something went wrong.'
        }
    }
    let newtoast = document.createElement("li");
    newtoast.className = `toast ${type}`;
    newtoast.innerHTML = `
    <div class="taost_border cursor-default px-[14px] h-auto bg-[#FEFEFA] flex justify-center items-center rounded-tr-[50%] rounded-br-[50%]">
      ${type === "success"
        ? `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="none">
               <circle cx="16" cy="16" r="16" fill="#12B76A" />
               <path d="M24.2512 8.57055C23.3562 7.63554 21.4744 7.46393 20.6006 8.57055L16.096 14.2823C15.3813 15.1889 14.6664 16.0958 13.9513 17.0029C13.6973 17.3245 13.3953 17.8076 13.0675 18.2556L12.8754 18.0526L11.4162 16.5238C9.09556 14.0891 5.44757 17.8197 7.76556 20.2545C8.96298 21.5111 10.1865 23.2688 11.809 23.9321C13.5893 24.6597 15.168 23.7844 16.3124 22.3652C18.995 19.0402 21.6051 15.6536 24.2512 12.3012C25.1309 11.182 25.2984 9.66499 24.2512 8.57055Z" fill="white"/>
             </svg>`
        : type === "error"
            ? `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" fill="none">
               <circle cx="16" cy="16" r="16" fill="#EF0044" />
               <path d="M23.2244 21.3648C23.7508 21.8917 23.7508 22.7115 23.2244 23.2384C22.9611 23.5019 22.6394 23.619 22.2884 23.619C21.9375 23.619 21.6157 23.5019 21.3525 23.2384L16.0002 17.8809L10.6478 23.2384C10.3846 23.5019 10.0629 23.619 9.71188 23.619C9.3609 23.619 9.03918 23.5019 8.77595 23.2384C8.24949 22.7115 8.24949 21.8917 8.77595 21.3648L14.1283 16.0073L8.77595 10.6498C8.24949 10.1228 8.24949 9.30311 8.77595 8.77614C9.30241 8.24918 10.1213 8.24918 10.6478 8.77614L16.0002 14.1336L21.3525 8.77614C21.879 8.24918 22.6979 8.24918 23.2244 8.77614C23.7508 9.30311 23.7508 10.1228 23.2244 10.6498L17.872 16.0073L23.2244 21.3648Z" fill="white" stroke="white" stroke-width="3"/>
             </svg>`
            : ""
    }
    </div>
    <div class="content flex ${link && "flex-col"} justify-center items-center pl-[6px]">
        <span class="text-sm md:text-base ${link && "text-center"} lg:text-base tracking-[0.34px] text-[#FEFEFA]">${message}</span>
		${link? `<div class='w-full flex justify-start'><a href='${base_url+'cart/'}' class='text-sm md:text-base lg:text-base tracking-[0.34px] text-[#FEFEFA] border-b border-white'>View Cart</a></div>`:''}
    </div>
    <div class="cross px-3 w-fit h-[27px] bg-[#FEFEFA] flex justify-center items-center pb-[5px]" onclick="(this.parentElement).remove()">
      ${type === "success"
        ? `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 11 11" fill="none">
               <path d="M10.715 9.37272C11.095 9.75312 11.095 10.3449 10.715 10.7253C10.525 10.9155 10.2927 11 10.0393 11C9.78599 11 9.55374 10.9155 9.36372 10.7253L5.5 6.85783L1.63628 10.7253C1.44626 10.9155 1.21401 11 0.960653 11C0.707294 11 0.475048 10.9155 0.285029 10.7253C-0.0950096 10.3449 -0.0950096 9.75312 0.285029 9.37272L4.14875 5.50528L0.285029 1.63785C-0.0950096 1.25745 -0.0950096 0.665706 0.285029 0.285303C0.665067 -0.0951009 1.25624 -0.0951009 1.63628 0.285303L5.5 4.15274L9.36372 0.285303C9.74376 -0.0951009 10.3349 -0.0951009 10.715 0.285303C11.095 0.665706 11.095 1.25745 10.715 1.63785L6.85125 5.50528L10.715 9.37272Z" fill="#12B76A"/>
             </svg>`
        : type === "error"
            ? `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 11 11" fill="none">
               <path d="M10.715 9.37272C11.095 9.75312 11.095 10.3449 10.715 10.7253C10.525 10.9155 10.2927 11 10.0393 11C9.78599 11 9.55374 10.9155 9.36372 10.7253L5.5 6.85783L1.63628 10.7253C1.44626 10.9155 1.21401 11 0.960653 11C0.707294 11 0.475048 10.9155 0.285029 10.7253C-0.0950096 10.3449 -0.0950096 9.75312 0.285029 9.37272L4.14875 5.50528L0.285029 1.63785C-0.0950096 1.25745 -0.0950096 0.665706 0.285029 0.285303C0.665067 -0.0951009 1.25624 -0.0951009 1.63628 0.285303L5.5 4.15274L9.36372 0.285303C9.74376 -0.0951009 10.3349 -0.0951009 10.715 0.285303C11.095 0.665706 11.095 1.25745 10.715 1.63785L6.85125 5.50528L10.715 9.37272Z" fill="#EF0044"/>
             </svg>`
            : ""
    }
    </div>
`;
    notifications.appendChild(newtoast);
    newtoast.time = 5000;
    newtoast.timeInterval = setInterval(() => {
        newtoast.time -= 50;
        if (newtoast.time <= 0) {
            clearInterval(newtoast.timeInterval);
        }
    }, 50);

    newtoast.timeOut = setTimeout(() => {
        clearInterval(newtoast.timeInterval);
        newtoast.remove();
    }, newtoast.time);
    newtoast.onmouseenter = () => {
        clearInterval(newtoast.timeInterval);
        clearTimeout(newtoast.timeOut);
    };
    newtoast.onmouseleave = () => {
        newtoast.timeInterval = setInterval(() => {
            newtoast.time -= 50;
            if (newtoast.time <= 0) {
                clearInterval(newtoast.timeInterval);
            }
        }, 50);
        newtoast.timeOut = setTimeout(() => {
            clearInterval(newtoast.timeInterval);
            newtoast.remove();
        }, newtoast.time);
    };

}



let mybutton = document.getElementById('myBtn');

window.onscroll = function () {
    scrollFunction()
};
function scrollFunction() {
    if(!mybutton) return;
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block"
    } else {
        mybutton.style.display = "none"
    }
};


window.addEventListener("DOMContentLoaded", function () {
    const input = document.querySelector(".input_focus");
    if (input) {
        input.focus();
    }
});



const cartBadges = document.querySelectorAll('.cartBadge');
cartBadges.forEach((cartBadge)=>{
    if (cartBadge) {
        const cartValue = cartBadge.getAttribute('data-value');
        if (cartValue && cartValue.trim() !== '') {
            cartBadge.classList.remove('hidden');
            cartBadge.classList.add('flex');
        } else {
            cartBadge.classList.add('hidden');
            cartBadge.classList.remove('flex');
        }
    }
})



document.addEventListener('DOMContentLoaded', () => {
    let counted = false;
    window.addEventListener('scroll', () => {
        const cards = document.querySelectorAll('.small_animate');

        cards.forEach(function (card, index) {
            const rect = card.getBoundingClientRect();
            const inView = (rect.top >= 0) && (rect.bottom <= window.innerHeight);

            if (inView) {
                setTimeout(() => {
                    card.classList.add('animate_in');
                }, index * 1000);
            }
        });

        if (counted) return;
        const section = document.getElementById('counter_section')?.getBoundingClientRect();
        if (section?.top >= 0 && section.bottom <= window.innerHeight) {
            document.querySelectorAll('[data-count]').forEach(animate => {
                let endValue = animate.dataset.count;
                let end = 0;
                let isThousand = false;
                let isMillion = false;
                let isHundred = false;
                let isTen = false;

                // Check for "K", "M", "K+", or "M+" in the value
                if (endValue.includes('K')) {
                    isThousand = true;
                    end = parseFloat(endValue) * 1000;
                } else if (endValue.includes('M+')) {
                    isMillion = true;
                    end = parseFloat(endValue) * 1000000;
                } else if (endValue.includes('+')) {
                    isHundred = true;
                    end = parseFloat(endValue) * 1000;
                } else if (endValue.includes('+')) {
                    isTen = true;
                    end = parseFloat(endValue) * 10;
                } else {
                    end = parseInt(endValue);
                }

                let duration = 3000, startTimestamp;

                const step = timestamp => {
                    if (!startTimestamp) startTimestamp = timestamp;
                    let progress = Math.min((timestamp - startTimestamp) / duration, 1);
                    let currentValue = Math.floor(progress * end);

                    // Format the displayed value based on the unit (K or M)
                    if (isThousand) {
                        animate.textContent = (currentValue / 1000).toFixed(0) + 'K+';
                    } else if (isMillion) {
                        animate.textContent = (currentValue / 1000000).toFixed(0) + 'M+';
                    } else if (isHundred) {
                        animate.textContent = (currentValue / 1000	).toFixed(0) + '+';
                    } else if (isTen) {
                        animate.textContent = (currentValue / 10	).toFixed(0) + '+';
                    } else {
                        animate.textContent = currentValue;
                    }

                    if (progress < 1) requestAnimationFrame(step);
                };
                requestAnimationFrame(step);
            });
            counted = true;
        }
    });
});

const scrollers = document.querySelectorAll(".scroller");

if(!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    addAnimation();
}

function addAnimation() {
    scrollers.forEach(scroller => {
        scroller.setAttribute("data-animated", true);
        const scrollerInner = scroller.querySelector('.scroller__inner');
        const scrollerContent = Array.from(scrollerInner.children);

        scrollerContent.forEach(item => {
            const duplicatedItem = item.cloneNode(true);
            duplicatedItem.setAttribute('aria-hidden', true);
            scrollerInner.appendChild(duplicatedItem);
        });
    });
}

document.querySelectorAll('input').forEach(input => {
    input.setAttribute('autocomplete', 'off');
});
